// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__31mnN","label":"Labeled_label__36mfc","divider":"Labeled_divider__bRSpY"};